module.exports = __webpack_public_path__ + "img/secure.6cb9783b.png";